import { render, staticRenderFns } from "./MFCForm.vue?vue&type=template&id=017499e3&scoped=true"
import script from "./MFCForm.vue?vue&type=script&lang=js"
export * from "./MFCForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017499e3",
  null
  
)

export default component.exports